import { create } from "zustand"

const STORAGE_KEY = "sadeo_device"

interface DeviceState {
  deviceUuid: string | null
  deviceNaziv: string | null
  companyId: number | null
  poslovnaJedinicaId: number | null
  kasaId: number | null
  load: () => void
  register: (uuid: string, naziv: string, companyId: number, pjId: number, kasaId: number) => void
  reset: () => void
}

export const useDeviceStore = create<DeviceState>((set) => ({
  deviceUuid: null,
  deviceNaziv: null,
  companyId: null,
  poslovnaJedinicaId: null,
  kasaId: null,
  load: () => {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      try { set(JSON.parse(stored)) } catch { localStorage.removeItem(STORAGE_KEY) }
    }
  },
  register: (uuid, naziv, companyId, pjId, kasaId) => {
    const data = { deviceUuid: uuid, deviceNaziv: naziv, companyId, poslovnaJedinicaId: pjId, kasaId }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
    set(data)
  },
  reset: () => {
    localStorage.removeItem(STORAGE_KEY)
    set({ deviceUuid: null, deviceNaziv: null, companyId: null, poslovnaJedinicaId: null, kasaId: null })
  }
}))

export function generateUuid(): string {
  if (crypto.randomUUID) return crypto.randomUUID()
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    const v = c === "x" ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
